var scope_0 = require('/opt/affilimate/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3393084dd692806ec3b099b70dacfd4e.js').default;
var scope_1 = require('/opt/affilimate/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/7f7d18f46e0852e1fe1c0a02295672b9.js').default;
var scope_2 = require('/opt/affilimate/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/816f9ed0ed466f66028c5239d3d56d8c.js').default;
var scope_3 = require('/opt/affilimate/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_4 = require('/opt/affilimate/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f74f7d991da14469b4e11c22de3890cb.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4 )
    